@if (displayIf) {
  <a mat-list-item
    class="pegase-menu-entry"
    [attr.data-tfa]="'mat-list-item-route_' + navTitle"
    [routerLink]="disabled ? null : path"
    routerLinkActive="active"
    #rla="routerLinkActive"
    [attr.aria-current]="rla.isActive ? 'page' : null"
    [class.disabled]="disabled"
    [disableRipple]="disabled"
    (focus)="focusHandler.emit()"
    >
    <span [matTooltip]="navTooltip? navTooltip:navTitle" matTooltipPosition="right" class="pegase-menu-entry_tooltip-wrapper">
      @if (svgIcon) {
        <mat-icon [svgIcon]="svgIcon" data-tfa="icon-svg-icon"></mat-icon>
      }
      @if (matIcon) {
        <mat-icon [attr.data-tfa]="'mat-list-item-icon_' + matIcon">{{matIcon}}</mat-icon>
      }
      {{ navTitle }}
    </span>
  </a>
}
